import { useCallback, useMemo } from "react";

import { useTranslation } from "react-i18next";

import Button from "../../../../button";
import Loading from "../../../../loading";

import { isEmptyList, isEmptyObject } from "../../../../../utils/validators";

function FreePlanCard(props) {
  const { loading, showRegister, onRegister } = props;

  const { t } = useTranslation();

  const title = useMemo(() => {
    return t(`plans.free.title`);
  }, [t]);

  const registerLabel = useMemo(() => {
    return t("button.create_account_free");
  }, [t]);

  const features = useMemo(() => {
    const features = t("plans.free.features");
    if (!isEmptyObject(features)) {
      return Object.values(features);
    }
    return [];
  }, [t]);

  const onRegisterHandler = useCallback(
    (evt) => {
      showRegister && onRegister && onRegister(evt);
    },
    [showRegister, onRegister]
  );

  return (
    <div className="free-plan-card__container">
      {loading && (
        <div className="free-plan-card__loading">
          <Loading />
        </div>
      )}
      <div className="free-plan-card__content">
        <div className="free-plan-card__header__container">
          <div className="free-plan-card__header__content">
            <span className="plan-icon icon icon-circle-alternate"></span>
            <span className="plan-title" title={title}>
              {title}
            </span>
            <div className="plan-price"></div>
            <div className="plan-button">
              {showRegister && (
                <Button
                  text
                  secondary
                  disabled={loading}
                  onClick={(evt) => onRegisterHandler(evt)}
                >
                  <span className="label" title={registerLabel}>
                    {registerLabel}
                  </span>
                </Button>
              )}
            </div>
          </div>
        </div>
        <div className="free-plan-card__body__container">
          <div className="free-plan-card__body__content">
            {!isEmptyList(features) && (
              <div className="plan-feature__list">
                {features.map((feature, idx) => (
                  <div key={idx} className="plan-feature__item">
                    <span className="item-icon icon icon-check-alternate"></span>
                    <span className="item-text">{feature}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default FreePlanCard;
